import GLightbox from 'glightbox';

var lightbox = {

  init: function () {

    const lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true
      //onOpen: () => {},
      //beforeSlideLoad: (slideData) => {}
    });
  }
}

export default lightbox;
